<template>
  <div
    :class="[
      resource.columns.center ? 'titled-markdown--center' : null,
      `titled-markdown--color-${resource.columns.color}`,
    ]"
    class="titled-markdown"
  >
    <Headline
      v-if="resource.columns.title"
      :color="resource.columns.color"
      :size="titleSize || resource.columns.titleSize || 4"
      :level="2"
    >
      <span v-editable="resource.columns.title" v-placeholder="'single'" />
    </Headline>
    <Wysiwyg
      v-if="resource.columns.text"
      :class="{ 'titled-markdown__text--large': resource.columns.large }"
      class="titled-markdown__text"
    >
      <div v-editable="resource.columns.text" v-placeholder="'multi'" />
    </Wysiwyg>
    <Arc
      :random-range-rotation="{ min: 0, max: 360 }"
      :random-range-position-x="[
        { min: -12, max: -11 },
        { min: 85, max: 92 }
      ]"
      :random-range-position-y="{ min: 20, max: 55 }"
    />
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Headline from 'beisheim/components/elements/headline'
import Wysiwyg from 'beisheim/components/elements/wysiwyg'
import Arc from 'beisheim/components/elements/arc'

export default {
  components: {
    Wysiwyg,
    Headline,
    Arc
  },
  mixins: [ editable ],
  props: {
    titleSize: {
      type: Number,
      default: undefined
    }
  },
  mounted () {
    this.$el.style.opacity = 1
    this.$el.style.transform = 'translateY(0px)'
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/grid';
@import 'beisheim/scss/scale';
@import 'beisheim/scss/font';
@import 'beisheim/scss/colors';
@import 'beisheim/scss/breakpoints';

.titled-markdown {
  position: relative;
  transform: translateY(50px);
  opacity: 0;
  transition: transform 800ms cubic-bezier(.17,.67,.29,1), opacity 400ms ease-out;
  @include grid-spacing(padding-left, 3);
  @include grid-spacing(padding-right, 3);
  margin: 0 auto;
  max-width: $max-width;

  @include from(4) {
    @include grid-spacing(padding-right, 7);
  }

  &--center {
    margin-left: auto;
    margin-right: auto;
  }

  &--color-black {
    color: gray(1);
  }

  &--color-white {
    color: gray(5);

    a {
      color: gray(5) !important;
      border-bottom-color: gray(5) !important;
    }
  }

  &__text {
    @include font(0);

    &--large {
      @include font(1);
    }
  }

}
</style>
